import React from 'react'
import Bloghero from '../components/blog/bloghero/bloghero'

const Blogs = () => {
  return (
    <div>
      <Bloghero />
    </div>
  )
}

export default Blogs
